const Tabby = ({ ...props }) => {
    return (
        <svg
            width="34"
            height="24"
            viewBox="0 0 34 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z"
                fill="url(#paint0_linear_9862_54638)"
            />
            <path
                d="M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z"
                stroke="#EAECF0"
            />
            <path
                d="M20.3649 10.4778V8.79056L15.4112 9.54718C16.8082 9.2521 17.6087 8.13229 17.6087 7.0125V6.31641H15.1016V9.59257L13.7197 9.81199V11.4993L15.1016 11.2874V12.0743L13.7273 12.2862V13.8977L15.1016 13.6859V15.6228C15.1847 17.3101 16.2947 18.3164 18.1146 18.3164C18.7641 18.3164 19.4135 18.1802 20.01 17.923L20.0251 17.9154V15.8044L19.9949 15.8196C19.64 15.9936 19.2473 16.0844 18.8547 16.0844C18.0089 16.0844 17.4728 15.9482 17.4728 15.2597V13.3151L20.3725 12.8688V11.2571L17.4728 11.7035V10.9167L20.3649 10.4778Z"
                fill="#292929"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_9862_54638"
                    x1="17"
                    y1="0"
                    x2="17"
                    y2="24"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3BFFC6" />
                    <stop offset="1" stopColor="#3BFE9C" />
                </linearGradient>
            </defs>
        </svg>
    )
}
export default Tabby
